// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + (chunkId === 347 ? "secondary" : chunkId) + "." + {"70":"0a94fdcdd889767cbfad","347":"f485fa7d4cb46aff2547"}[chunkId] + ".css";
};